function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPotencia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M22.216,5.148c-0.331-0.745-0.692-1.476-1.086-2.191c-0.375-0.681-0.762-1.5-1.585-1.717 c-0.964-0.254-1.682,0.424-2.221,1.117c-0.5,0.643-0.993,1.291-1.478,1.944c-0.993,1.335-1.961,2.689-2.899,4.063 c-0.321,0.47-0.056,1.173,0.409,1.431c0.535,0.297,1.11,0.062,1.431-0.409c0.77-1.129,1.558-2.246,2.368-3.346 c0.153-0.207,0.309-0.411,0.464-0.616c-0.481,2.86-1.199,5.728-2.681,8.239c-0.802,1.358-1.847,2.586-3.126,3.518 c-1.474,1.074-3.141,1.798-4.878,2.329c-2.007,0.613-4.077,0.985-6.141,1.342c-0.561,0.097-0.867,0.796-0.723,1.301 c0.17,0.596,0.738,0.82,1.301,0.723c3.816-0.66,7.812-1.397,11.093-3.587c3.057-2.04,4.952-5.169,6.074-8.611 c0.605-1.856,0.984-3.776,1.277-5.703c0.242,0.479,0.475,0.963,0.683,1.457c0.55,1.303,0.996,2.645,1.348,4.015 c0.337,1.313,2.361,0.734,2.024-0.578C23.455,8.249,22.896,6.677,22.216,5.148z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotencia);
export default __webpack_public_path__ + "static/media/potencia.cb308d53.svg";
export { ForwardRef as ReactComponent };